import { object, array, bool } from 'prop-types'

import Category from '@/components/Category'
import SEO from '@/components/SEO'
import EnhancedListProvider from '@/context/EnhancedList'
import { SORT, FILTERS, SECTIONS } from '@/constants'
import Layout from '@/layout'

const productLabel = process.env.GATSBY_PRODUCT_LABEL
const sortOptions = Object.values(SORT)

const CampaignTemplate = ({
  campaign,
  products,
  filtersOpenOnInit,
  hasCategoryFilter,
}) => {
  if (!campaign) {
    return null
  }

  const campaignApps = campaign?.applications?.reduce(
    (items, { id, hidden }) => {
      const app = !hidden && products?.find((app) => app.id === id)
      if (app) items.push(app)
      return items
    },
    []
  )

  const category = {
    slug: campaign?.id,
    name: campaign?.name,
  }

  const supportedFilters = [
    FILTERS.CATEGORY.ID,
    FILTERS.PAYMENT.ID,
    'sortBy',
    FILTERS.COMPATIBILITY.ID,
    FILTERS.WIDGET_PLACEMENT.ID,
  ]

  // We are using Category component due to similar content and limitations.
  return (
    <EnhancedListProvider
      items={campaignApps}
      defaultSortValue={SORT.RECOMMENDED.VALUE}
      defaultSortOptions={sortOptions}
      supportedFilters={supportedFilters}
      section={SECTIONS.APPS}
    >
      <Layout category={category} headerLabel={campaign?.name}>
        <Category
          name={campaign?.name}
          headline={campaign?.description}
          campaign={{ ...campaign, applications: campaignApps }}
          filtersOpenOnInit={filtersOpenOnInit}
          hasCategoryFilter={hasCategoryFilter}
          allApps={products}
        />
      </Layout>
    </EnhancedListProvider>
  )
}

CampaignTemplate.propTypes = {
  campaign: object,
  products: array,
  filtersOpenOnInit: bool,
  hasCategoryFilter: bool,
}

export default CampaignTemplate

/* eslint-disable react/prop-types */
export const Head = ({ campaign, path }) => (
  <SEO
    title={`${campaign?.name} | ${productLabel} Integrations`}
    description={
      campaign?.description ||
      `Extend your ${productLabel} with powerful features to get your work done faster.`
    }
    path={path}
  />
)
/* eslint-enable react/prop-types */
